export default {
	setBanks: (state, banks) => {
		state.banks = banks
	},
}
